// extracted by mini-css-extract-plugin
export default {"BusinessesCard":"BusinessesList_BusinessesCard__+0+he"};